import React, { useState } from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import "../style/contact.css";

export default function Contact() {
  const [formData, setFormData] = useState({
    nom: "",
    email: "",
    message: "",
    entreprise: "",
  });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSent(false);

    // Vérification des champs obligatoires
    if (!formData.nom || !formData.email || !formData.message) {
      setError("Merci de remplir tous les champs.");
      return;
    }

    // Vérification email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError("Merci de saisir une adresse email valide.");
      return;
    }

    // Vérification checkbox RGPD
    const checkbox = document.querySelector('input[name="consent"]');
    if (!checkbox || !checkbox.checked) {
      setError("Merci de cocher la case de consentement RGPD.");
      return;
    }

    try {
      const response = await fetch("https://formspree.io/f/mdkljgzl", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          nom: formData.nom,
          email: formData.email,
          message: formData.message,
          entreprise: formData.entreprise,
        }),
      });

      if (response.ok) {
        setSent(true);
        setFormData({ nom: "", email: "", message: "", entreprise: "" });
        checkbox.checked = false; // reset la checkbox
      } else {
        const data = await response.json();
        setError(data.error || "Une erreur est survenue, veuillez réessayer.");
      }
    } catch {
      setError("Erreur réseau, veuillez réessayer.");
    }
  };

  return (
    <div className="contact-container">
      <section className="contact-left" data-aos="fade-down-right">
        <h2>Contactez-nous</h2>
        {sent && <p className="success-msg">Merci pour votre message !</p>}
        {error && <p className="error-msg">{error}</p>}

        <form onSubmit={handleSubmit} className="contact-form" noValidate>
          <label htmlFor="nom">Nom</label>
          <input
            id="nom"
            name="nom"
            type="text"
            value={formData.nom}
            onChange={handleChange}
            required
            placeholder="Votre nom"
          />

          <label htmlFor="email">Email</label>
          <input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder="exemple@mail.com"
          />

          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
            placeholder="Votre message..."
          />

          <button type="submit" className="btn-submit">
            Envoyer
          </button>
          <div className="consent-wrapper">
            <label htmlFor="consent">
              <input type="checkbox" id="consent" name="consent" required />
              <p>
                J’autorise Europe Rapide Expo à collecter et traiter mes données
                personnelles uniquement dans le cadre de la gestion de ma
                demande, conformément au Règlement Général sur la Protection des
                Données (RGPD). *
              </p>
            </label>
          </div>
        </form>
      </section>

      <section className="contact-right" data-aos="fade-down-left">
        <h2>Nos Informations</h2>
        <div className="location-info">
          <p>
            <strong>Adresse :</strong> ZAC de Montvrain II, 4-10 Rue Louise de
            Vilmorin, 91540 Mennecy
          </p>
          <p>
            <strong>Téléphone :</strong> 01 60 87 20 02
          </p>
          <p>
            <strong>Email :</strong> contact@ere91.com
          </p>
        </div>

        <h3>Suivez-nous</h3>
        <ul className="social-icons">
          <li>
            <a
              href="https://www.facebook.com/profile.php?id=100070063475044"
              className="facebook"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
          </li>

          <li>
            <a
              href="https://www.instagram.com/accounts/onetap/?next=%2Feuroperapideexpo%2F"
              className="instagram"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/company/74368705/admin/dashboard/"
              className="linkedin"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>
          </li>
        </ul>
      </section>
    </div>
  );
}
